export enum TipoItemControleEstoque {
    "produto" = "produto",
    "sabor" = "sabor",
    "borda" = "borda",
    "item" = "item",
    "massa" = "massa"
}